// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app\\components\\shared\\Tag\\index.ts"
);
import.meta.hot.lastModified = "1757171103360.6035";
}
// REMIX HMR END

export { Tag } from "./Tag";